export const SET_FILTER_GROUPS = 'SET_FILTER_GROUPS';

export const setFilterGroups = (payload) => {
    return {
        type: SET_FILTER_GROUPS,
        payload
    }
};